/**
 * Minimal color definitions for bc-widgets
 * Following the naming convention: colorName_hexCode
 */
const colors = {
  // Primary colors
  primary: "#031425",
  white: "#fff",

  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",

  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",

  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",

  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",

  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",

  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",

  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)",
} as const;

export default colors;
